module.exports = __webpack_public_path__ + "img/004.ffb94207.png";